import { ListSortDirection, Sort } from "src/models/api/sort";
import { TnAAbsenceTypeDTO, TnAAbsenceTypeSTO } from "../../models/tna";
import { BaseApiService } from "../base/base-api.service";

export class TnAAbsenceTypesApiService extends BaseApiService<TnAAbsenceTypeDTO, TnAAbsenceTypeSTO> {
  constructor() {
    super({
      servicePath: "/TnAAbsenceTypes",
      loadItemsPath: "/GetTnAAbsenceTypes",
      saveItemsPath: "/SaveTnAAbsenceTypes",
    });
    this.defaultSort = [
      {
        name: "sequence",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
